import React from 'react';
import { aboutUs } from '../data/aboutUs';
import { useVoice } from '../hooks/useVoice';
import Fade from 'react-reveal/Fade';
import Bounce from 'react-reveal/Bounce';

const Innovations = () => {
  const Speak = useVoice();

  return (
    <div className='whatWeDo'>
      <div className='px-5 header-title row text-center'>
        <div className='col-md-10 col-lg-8 mx-auto'>
          <Bounce>
            <h2>
              <span>Innovations</span>
            </h2>
          </Bounce>
          <div className='doTexts py-3'>
            <Fade top>
              <h4>Zero Export Controller (ZEC) </h4>
              <p>{aboutUs.do} </p>
            </Fade>
            <Fade bottom>
              <h4>Flash Technology </h4>
              <p>{aboutUs.doTwo}</p>
            </Fade>
            <Fade bottom>
              <h4>Delta System</h4>
              <p>
                {aboutUs.doThree}{' '}
                <Speak
                  text={
                    'Zero Export Controller (ZEC) ' +
                    aboutUs.do +
                    'Flash Technology ' +
                    aboutUs.doTwo +
                    'Delta System' +
                    aboutUs.doThree
                  }
                />
              </p>
            </Fade>
          </div>
        </div>
        <div id='milestones'></div>
      </div>
    </div>
  );
};

export default Innovations;
